import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Stack } from "@similarweb/ui-components/foundations";

export const StyledPlaybookSummaryRow = styled(Stack)`
    border-bottom: 1px solid ${colorsPalettes.carbon["50"]};

    &:last-child {
        border-bottom: none;
    }
`;
